<template>
  <v-dialog v-model="dialog" width="500">
    <v-card elevation="2">
      <v-card-title class="text-h5 grey lighten-2">
        Erreur
      </v-card-title>

      <v-card-text class="text-center py-5">
        {{ errorMessage }}
      </v-card-text>

      <v-divider></v-divider>

      <v-card-actions>
        <v-spacer></v-spacer>
        <v-btn color="#51bdcb" text @click="logout()">
          Se deconnecter
        </v-btn>
        <v-btn color="#51bdcb" text @click="dialog = false">
          OK
        </v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
export default {
  name: 'PopUpError',

  data: () => ({
    dialog: true,
    errorMessage:
      'Une erreur est survenue, votre authentification à peut être expirée dans ce cas veuillez vous reconnecter',
  }),

  methods: {
    logout() {
      if (localStorage) {
        localStorage.removeItem('apollo-token');
      }
      this.$router.push('/');
    },
  },
};
</script>

<style></style>
